import { refreshLists } from '../inbox/useLists.js';
import { usePolling } from '../hooks/usePolling.js';
import { syncChatDayLists } from '../lib/facade.js';

export const CHAT_DAY_SYNC_MS = 60_000;

/** While chat-emp is open, files jobseekers who joined the recruiter's Chat Day into its list. */
export function useChatDayListSync(enabled: boolean): void {
  usePolling(
    () => {
      syncChatDayLists()
        .then(({ changed }) => (changed ? refreshLists() : undefined))
        .catch(() => undefined);
    },
    enabled,
    CHAT_DAY_SYNC_MS,
  );
}
